import { render, staticRenderFns } from "./DriverInvoiceDetail.vue?vue&type=template&id=2336dd22&scoped=true&"
import script from "./DriverInvoiceDetail.vue?vue&type=script&lang=js&"
export * from "./DriverInvoiceDetail.vue?vue&type=script&lang=js&"
import style0 from "./DriverInvoiceDetail.vue?vue&type=style&index=0&id=2336dd22&scoped=true&lang=css&"
import style1 from "./DriverInvoiceDetail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2336dd22",
  null
  
)

export default component.exports